import useResetPassword from './useResetPassword';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import Container from '@/components/Container';
import Button from '@/components/Button';
import { Link } from 'react-router-dom';

const ForgotPassword = () => {
  const { forgotPasswordPage, handleSubmitForgotPassword, registerForgotPassword, isLoading } = useResetPassword();

  if (!forgotPasswordPage) return null;

  return (
    <Container className="h-full">
      <div className="col-span-12 flex min-h-0 items-center justify-center py-4">
        <div className="flex max-h-[90dvh] w-full max-w-[500px] flex-col items-start overflow-auto rounded-2xl bg-white p-8 shadow-lg">
          <img
            className="mb-4 h-auto w-[100px] self-start"
            src={forgotPasswordPage?.pageImage.data?.attributes?.url}
            alt={forgotPasswordPage?.pageImage.data?.attributes?.alternativeText || 'Logo'}
          />
          <div className="flex flex-col items-start">
            <h2 className="mb-4 text-center font-haffer text-sh-28-32 font-bold leading-9 tracking-tight text-gray-900">
              {forgotPasswordPage?.forgotPasswordTitle}
            </h2>

            <p className=" mb-4 font-haffer text-sh-xs">{forgotPasswordPage?.forgotPasswordDescription}</p>

            <form onSubmit={handleSubmitForgotPassword} className="w-full">
              <div className=" mb-8 w-full">
                <Label>
                  <p className="mb-2 text-sh-xs">{forgotPasswordPage?.customerEmailAddressTitle}</p>
                </Label>
                <Input
                  placeholder={forgotPasswordPage?.customerEmailAddressTitle}
                  type="email"
                  {...registerForgotPassword('email')}
                />
              </div>

              <Button type="submit" theme="solid" className="mb-4" loading={isLoading} showChevron={false}>
                {forgotPasswordPage?.sendMeCta}
              </Button>
            </form>

            <Link
              className="text-center font-haffer text-sh-xs font-bold text-people-teal-600 hover:!text-people-blue-600"
              to="/login">
              {forgotPasswordPage?.backToLoginCta}
            </Link>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ForgotPassword;
